import { Col, DatePicker, Form, Select } from "antd";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import {
  GET_INVENTORY_DETAILS,
  STYLE_MERCHANDISING_LIST,
  GET_ITEM_CATEGORIES,
  CHALLAN_LIST
} from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import CustomDatePicker from "common/CustomDatePicker";
import { isArrayAndHasValue } from "utils/functions";

const InventoryDetailFilterFields = ({ initialTableData }) => {
  // UX sweep default (fix round 1): last 7 days ending today. Used only by
  // "inventory_details" (this page), so an unconditional default is safe.
  // Final fix wave (I2): computed inside the component body (not module scope) so a
  // long-open tab re-evaluates "today" on the next render instead of freezing it at the
  // moment the JS bundle first loaded.
  const DEFAULT_START_DATE = moment().subtract(6, "days").format("YYYY-MM-DD");
  const DEFAULT_END_DATE = moment().format("YYYY-MM-DD");
  // States
  const [suppliersList, setSuppliersList] = useState(null);
  const [styleList, setStyleList] = useState([]);
  const [itemCategoryList, setItemCategoryList] = useState([]);
  const [challanList, setChallanList] = useState([]);
  // Antd
  const { Option } = Select;

  const getAllInventoryDetail = useCallback(async () => {
    const query = `${GET_INVENTORY_DETAILS}`;

    const response = await getData(query);

    if (response?.status === 200) {
      setSuppliersList(response?.data?.data?.suppliers);}
  }, []);

  const getStyleList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      style_no: filterValues?.style_no || "",
    };
    const response = await getData(STYLE_MERCHANDISING_LIST, false, bodyData);

    if (response && response?.data?.code === 200) {
      setStyleList(response?.data?.data?.data || []);
    }
  };
  

  const getItemCategoryList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      name: filterValues?.name || "",
    };
    const response = await getData(GET_ITEM_CATEGORIES, false, bodyData);

    if (response && response?.data?.code === 200) {
      setItemCategoryList(response?.data?.data?.data || []);
    }
  };

  const getAllChallan = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      name: filterValues?.name || "",
    };
    const response = await getData(CHALLAN_LIST, false, bodyData);
    if (response && response?.data?.code === 200) {
      setChallanList(response?.data?.data?.data || []);
    }
  };

  useEffect(() => {
    getAllInventoryDetail();
    getStyleList();
    getItemCategoryList();
    getAllChallan();
  }, []);

  return (
    <>
      <Col span={4}>
        <Form.Item
          label="Start Date"
          name="start_date"
          required
          initialValue={DEFAULT_START_DATE}
          rules={[
            {
              required: true,
              message: "Start Date is required",
            },
          ]}
        >
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item
          label="End Date"
          name="end_date"
          required
          initialValue={DEFAULT_END_DATE}
          rules={[
            {
              required: true,
              message: "End Date is required",
            },
          ]}
        >
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>

      <Col span={4}>
        <Form.Item label="Style No." name="style_id">
          <Select
            showSearch
            placeholder="Select a Style"
            optionFilterProp="children"
            size="small"
            onSearch={(value) => getStyleList({ style_no: value })}
            allowClear
            onClear={() => getStyleList()}
          >
            {isArrayAndHasValue(styleList) &&
              styleList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.style_no}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      {/* <Col span={4}>
        <Form.Item label="Suppliers" name="supplier_id">
          <Select
            showSearch
            placeholder="Select an supplier"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children[0].toLowerCase().includes(input.toLowerCase())
            }
            size="small"
          >
            {isArrayAndHasValue(suppliersList) &&
              suppliersList.map((supplier) => (
                <Option value={supplier.id} key={supplier.id}>
                  {supplier.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col> */}
      <Col span={4}>
        <Form.Item label="Item Category" name="item_category_ids">
          <Select
            mode="multiple"
            showSearch
            placeholder="Select Item Category(s)"
            optionFilterProp="children"
            size="small"
            onSearch={(value) => getItemCategoryList({ name: value })}
            allowClear
            onClear={() => getItemCategoryList()}
          >
            {isArrayAndHasValue(itemCategoryList) &&
              itemCategoryList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Challan No." name="challan_ids">
          <Select
            mode="multiple"
            showSearch
            placeholder="Select Challan(s)"
            optionFilterProp="children"
            size="small"
            onSearch={(value) => getAllChallan({ name: value })}
            allowClear
            onClear={() => getAllChallan()}
          >
            {isArrayAndHasValue(challanList) &&
              challanList.map((challan) => (
                <Option value={challan.id} key={challan.id}>
                  {challan.challan_no}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
    
  );
};

export default InventoryDetailFilterFields;
